export default "__VITE_ASSET__CEYE3ElE__"